import { Dialog, DialogContent } from '@parrot-software/design-system';

import { BlockCreationWizard } from '@subscriptions/presentation/components/specific';

/**
 * Route-level entry point for the subscription block creation wizard.
 *
 * Renders the wizard as a fullscreen Dialog overlay so it covers the app shell
 * entirely. The Dialog stays open while the user is on this route; closing the
 * wizard navigates away (see {@link BlockCreationWizard}'s `handleClose`), which
 * unmounts the Dialog automatically.
 *
 * - `h-[100dvh] max-w-none` — fullscreen height, no width cap.
 * - `border-0 p-0` — flush edges so the split layout reaches the viewport.
 * - `[&>button]:hidden` — hides the default Radix close button; the layout
 *   provides its own X anchored over the right panel.
 */
export const SubscriptionBlockCreatePage = () => (
  <Dialog open>
    <DialogContent className="h-[100dvh] max-w-none border-0 p-0 [&>button]:hidden">
      <BlockCreationWizard />
    </DialogContent>
  </Dialog>
);
